import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const DeleteScheduleApiImpl = async (id: string): Promise<Either<ErrorEntity, void>> => {
    try {
        const relativeUrl: string = `/schedules/${id}`;
        await di.get<HostApi>(HostApiName).remove(relativeUrl);
        return right(undefined);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default DeleteScheduleApiImpl;